import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getRecords } from './api/airtable';

export default function ComposeEmailPage() {
  const { recordId } = useParams();
  const reason = new URLSearchParams(window.location.search).get('reason') || 'generic';
  const [student, setStudent] = useState(null);
  const [emailBody, setEmailBody] = useState('');

  useEffect(() => {
    const fetchStudent = async () => {
      try {
        const records = await getRecords();
        console.log("Fetching student by ID:", recordId);
        console.log("Reason:", reason);
        console.log("All records length:", records.length);

        const match = records.find(record => record.id === recordId);
        if (!match) {
          console.warn("No matching record found for ID:", recordId);
        }

        setStudent(match);

        if (match) {
          const name = match.fields['First Name'] || 'there';
          setEmailBody(getDefaultMessage(reason, name, match.fields));
        }
      } catch (err) {
        console.error("Error fetching student:", err);
      }
    };

    fetchStudent();
  }, [recordId, reason]);

  const getDefaultMessage = (reason, name, fields) => {
    switch (reason) {
      case 'birthday':
        return `Dear ${name},\n\nWishing you the happiest of birthdays! We’re so glad to have you as part of Stanford’s Pathways community.\n\nPlease feel free to reach out if there’s ever anything you need.\n\nWarmly,\nDr. Anthony`;
      case 'mcatReminder':
        return `Dear ${name},\n\nJust a quick reminder to register for the MCAT if you haven’t already. If you have any questions or need support preparing, feel free to reach out.\n\nWe’re cheering you on!\n\nWarmly,\nDr. Anthony`;
      case 'longTimeNoContact':
        return `Dear ${name},\n\nIt’s been a little while since we’ve been in touch, and I just wanted to check in and see how things are going. We’re here to support you in your journey through the Pathways program.\n\nHope to hear from you soon!\n\nWarmly,\nDr. Anthony`;
      default:
        return `Dear ${name},\n\nI just wanted to reach out and say hello. Please feel free to reach out if you ever need support, have questions, or just want to reconnect.\n\nAll the best,\nDr. Anthony`;
    }
  };

  if (student === null) return <p className="p-8 text-red-600">Student not found.</p>;
  if (!student) return <p className="p-8">Loading student info...</p>;

  return (
    <div className="p-8">
      <h1 className="text-2xl font-bold text-[#8C1515] mb-4">Compose Email to {student.fields['Full Name']}</h1>
      <textarea
        className="w-full border border-gray-300 rounded p-4 min-h-[300px] font-mono"
        value={emailBody}
        onChange={e => setEmailBody(e.target.value)}
      />

      {/* Convert newline characters to %0A for mailto compatibility */}
      {(() => {
        const recipient = student.fields['Email'] || '';
        const subject = `Hello from Stanford Pathways`;
        const encodedBody = encodeURIComponent(emailBody);

        const mailtoLink = `mailto:${recipient}?subject=${encodeURIComponent(subject)}&body=${encodedBody}`;

        return (
          <a
            href={mailtoLink}
            className="inline-block mt-4 px-6 py-2 bg-[#8C1515] text-white rounded hover:bg-[#A6192E] transition-colors"
          >
            Open in Mail App
          </a>
        );
      })()}
    </div>
  );
}
